export default __webpack_public_path__ + "static/media/Heart.5ea2d3fe.svg";